module.exports = __webpack_public_path__ + "img/LPTemp2.345dd492.png";